import React, { useState } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepProps } from './types';
import { Description } from '@material-ui/icons';
import { StepButtonBar } from './StepButtonBar';

const PRIMARY = '#c4122f';

interface AddStep5ConfirmProps extends StepProps {
  selectedLawsData: any[];
  selectedCompanyUnit: any;
  selectedUsers: any[];
  hasResponsible: boolean;
  onConfirmAdd: () => Promise<void>;
}

const AddStep5Confirm = ({
  selectedLawsData,
  selectedCompanyUnit,
  selectedUsers,
  hasResponsible,
  onConfirmAdd,
  onBack,
  onCancel,
}: AddStep5ConfirmProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isAdding, setIsAdding] = useState(false);

  const handleConfirmAdd = async () => {
    setIsAdding(true);
    try {
      await onConfirmAdd();
    } catch (error) {
      console.error('Add failed:', error);
      setIsAdding(false);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: '100%',
            flexShrink: 0,
            padding: isMobile ? theme.spacing(2) : theme.spacing(3),
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
          }}
        >
          <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(2),
              lineHeight: 1.4,
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({ 
              id: 'law-portal.manage.legal-list.Add-law', 
            })}
          </Typography>

          <Typography
            variant="body2"
            style={{
              marginBottom: theme.spacing(2),
              color: '#555',
              fontSize: '14px',
            }}
          >
             {formatMessage({ 
              id: 'law-portal.manage.add-laws.confirmTitle', 
              defaultMessage: 'Laws to add to {unit}' 
            }, { unit: selectedCompanyUnit?.map((item: any) => item.name)
  .join(', ') || '-' })}
            {/* {formatMessage({ 
              id: 'law-portal.manage.add-laws.confirmMessage', 
              defaultMessage: 'Are you sure you want to add these laws? ' 
            })} */}
          </Typography>

          {/* Responsible Summary */}
          {/* {hasResponsible && selectedUsers && selectedUsers.length > 0 && (
            <Box style={{ marginBottom: theme.spacing(2) }}>
              <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: '8px', fontSize: '14px' }}>
                {formatMessage({ 
                  id: 'law-portal.manage.add-laws.responsiblePersons', 
                  defaultMessage: 'Responsible Person(s)' 
                })}
              </Typography>
              <Typography variant="body2" style={{ fontSize: '14px', color: '#555' }}>
                {selectedUsers.map(u => u.label).join(', ')}
              </Typography>
            </Box>
          )} */}

           <Typography
            variant="body2"
            style={{
              marginBottom: theme.spacing(2),
              color: '#555',
              fontSize: '14px',
            }}
          >
            {formatMessage({ 
              id: 'law-portal.manage.add-laws.confirmMessage', 
              defaultMessage: 'Are you sure you want to add these laws? ' 
            })}
          </Typography>

          {/* Laws List - Simple list format like delete confirmation */}
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            {selectedLawsData.map((law) => (
              <Box
                key={law.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 14px',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'green',
                    borderRadius: '6px',
                    flexShrink: 0,
                  }}
                >
                  <Description style={{ color: '#fff', fontSize: '24px' }} />
                </Box>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 500, fontSize: '14px', color: '#222' }}
                >
                  {law?.number} – {law?.name}
                </Typography>
              </Box>
            ))}
          </Box>
        </div>
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleConfirmAdd}
          nextLabel="form.save"
          nextDisabled={isAdding}
          formatMessage={formatMessage}
          showBack={true}
        />
      </Box>
    </div>
  );
};

export default AddStep5Confirm;
